import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { ITicketingState, ITicketGroupListResponse, IApplicationState, AppActionCreators, TicketingActionCreators, ITicketGroupResponse, ICenterListResponse, CenterActionCreators, ICenterState, ITicketGroupCategoryListResponse } from '@nkr/store/index';
import { IUserListResponse, ITicketGroup, IBaseResponse, ITicketGroupUsersRequest, IUserItem } from '@nkr/models/index';
import { Button, DropdownButton, MenuItem, FormControl, ToggleButtonGroup, ToggleButton, Glyphicon, Well } from 'react-bootstrap';
import GroupUsers from './group-users/group-users';
import { toast } from 'react-toastify';
import GroupAddEdit from './add-edit/group-add-edit';
import GroupDelete from './group-delete';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, ICellRendererParams, IHeaderParams, ValueGetterParams } from 'ag-grid-community';
import RankRenderer from '@nkr/views/admin/center/list/common/rank-renderer';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { ActionItems } from './action-items';
import { GridWrapper, HeaderWrapper } from './styles';

interface IProps { }

interface IStateProps {
    ticketing: ITicketingState,
    centers: ICenterState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getTicketGroups: () => Promise<ITicketGroupListResponse>,
    saveTicketGroup: (group: ITicketGroup) => Promise<ITicketGroupResponse>,
    deleteTicketGroup: (groupId: number) => Promise<IBaseResponse>,
    saveTicketGroupUsers: (request: ITicketGroupUsersRequest) => Promise<ITicketGroupResponse>,
    getUserList: () => Promise<IUserListResponse>,
    getCenterList: () => Promise<ICenterListResponse>,
    getTicketGroupCategoryList: () => Promise<ITicketGroupCategoryListResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    category: number,
    internalExternal: number,
    search: string,
    addEdit: {
        show: boolean,
        data: ITicketGroup
    },
    groupUsers: {
        show: boolean,
        group: ITicketGroup
    },
    groupDelete: {
        show: boolean,
        group: ITicketGroup
    },
    minHeight: number,
    columns: ColDef[]
}

class GroupList extends React.Component<TProps, IState> {
    readonly state: IState = {
        category: 0,
        internalExternal: 0,
        search: '',
        addEdit: {
            show: false,
            data: null
        },
        groupUsers: {
            show: false,
            group: null
        },
        groupDelete: {
            show: false,
            group: null
        },
        minHeight: 400,
        columns: [
            {
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>R#</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'Rank',
                cellRendererFramework: (props: ICellRendererParams) => <RankRenderer {...props} />,
                width: 50
            },

            {
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Name</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'Name',
                field: 'name',
                width: 400
            },

            {
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Category</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'Category',
                field: 'categoryDescription',
                width: 400
            },

            {
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}><HeaderWrapper>Internal</HeaderWrapper></SortableHeaderComponent>,
                headerName: 'Internal?',
                field: 'isNkr',
                cellRendererFramework: (props: ICellRendererParams) => (
                    <span>{props.value ? <Glyphicon glyph='ok' /> : null}</span>
                ),
                width: 190
            },

            {
                headerName: '',
                field: 'id',
                cellClass: 'action-menu',
                cellRendererFramework: (props: ICellRendererParams) => (
                    <>
                        <DropdownButton
                            bsStyle='primary'
                            bsSize='xs'
                            title='Actions'
                            id={'actions-' + props.value}
                            pullRight
                        >
                            <MenuItem eventKey={ActionItems.EDIT} onClick={() => this.handleActionItem(ActionItems.EDIT, props.value)}>Edit</MenuItem>
                            <MenuItem eventKey={ActionItems.DELETE} onClick={() => this.handleActionItem(ActionItems.DELETE, props.value)}>Delete</MenuItem>
                            <MenuItem divider />
                            <MenuItem eventKey={ActionItems.USERS} onClick={() => this.handleActionItem(ActionItems.USERS, props.value)}>Users</MenuItem>
                        </DropdownButton>
                    </>
                ),
                width: 70
            },
        ]
    }

    componentWillMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Loading ticketing groups, one moment please...').then(() => {
            return Promise.all([
                this.props.getTicketGroups(),
                this.props.getUserList(),
                this.props.getCenterList(),
                this.props.getTicketGroupCategoryList()
            ]).then(() => {
                this.props.hideLoading();
            });
        });
    }

    filteredData = () => {
        let groups = this.props.ticketing.groups.filter(group => {
            let category = this.state.category > 0 ? group.category == this.state.category : true;
            let internalExternal = true;

            if (this.state.internalExternal == 1) {
                internalExternal = group.isNkr == true;
            }

            if (this.state.internalExternal == 2) {
                internalExternal = group.isNkr == false;
            }

            let search = this.state.search != '' ? group.name.toUpperCase().indexOf(this.state.search.toUpperCase()) >= 0 : true;

            return category && internalExternal && search;
        });

        return groups;
    }

    handleCategoryChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            category: parseInt(e.currentTarget.value)
        });
    }

    handleInternalExternalChange = (internalExternal: number) => {
        this.setState({
            internalExternal
        });
    }

    handleSearchChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            search: e.currentTarget.value
        });
    }

    handleAddGroup = () => {
        this.setState({
            addEdit: {
                show: true,
                data: null
            }
        });
    }

    handleEditGroup = (group: ITicketGroup) => {
        this.setState({
            addEdit: {
                show: true,
                data: group
            }
        });
    }

    handleAddEditSave = (group: ITicketGroup) => {
        this.setState({
            addEdit: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Saving ticketing group, one moment please...').then(() => {
                this.props.saveTicketGroup(group).then(response => {
                    if (response.data.success) {
                        toast.success('Successfully saved the ticket group');
                    }

                    this.props.hideLoading();
                });
            });
        });
    }

    handleAddEditCancel = () => {
        this.setState({
            addEdit: {
                show: false,
                data: null
            }
        });
    }

    handleEditGroupUsers = (groupId: number) => {
        let group = this.props.ticketing.groups.find(x => x.id == groupId);

        this.setState({
            groupUsers: {
                show: true,
                group: group
            }
        });
    }

    handleEditGroupUsersSave = (groupId: number, users: IUserItem[]) => {
        this.setState({
            groupUsers: {
                show: false,
                group: null
            }
        }, () => {
            var request: ITicketGroupUsersRequest = {
                groupId,
                users: users.map(user => {
                    return { userId: user.user.id, isPrimary: user.isPrimary };
                })
            };

            this.props.showLoading('Updating users for ticketing group, one moment please...').then(() => {
                this.props.saveTicketGroupUsers(request).then(response => {
                    if (response.data.success) {
                        toast.success('Successfully update the ticket group users');
                    }

                    this.props.hideLoading();
                });
            });
        });
    }

    handleEditGroupUsersCancel = () => {
        this.setState({
            groupUsers: {
                show: false,
                group: null
            }
        });
    }

    handleDeleteGroup = (group: ITicketGroup) => {
        this.setState({
            groupDelete: {
                show: true,
                group
            }
        });
    }

    handleDelete = (groupId: number) => {
        this.setState({
            groupDelete: {
                show: false,
                group: null
            }
        }, () => {
            this.props.showLoading('Deleting ticketing group, one moment please...').then(() => {
                this.props.deleteTicketGroup(groupId).then(response => {
                    if (response.data.success) {
                        toast.success('Successfully deleted the ticket group');
                    }

                    this.props.hideLoading();
                });
            });
        });
    }

    handleDeleteCancel = () => {
        this.setState({
            groupDelete: {
                show: false,
                group: null
            }
        });
    }

    handleActionItem = (eventKey: string, id: number) => {
        let data = this.props.ticketing.groups.find(x => x.id == id);

        switch (eventKey) {
            case ActionItems.EDIT:
                this.handleEditGroup(data);
                break;

            case ActionItems.DELETE:
                this.handleDeleteGroup(data);
                break;

            case ActionItems.USERS:
                this.handleEditGroupUsers(id);
                break;
        }
    }

    render = () => {
        const users = this.props.ticketing.users.filter(() => {
            if (this.state.groupUsers.group) {
                return true;
            } else {
                return false;
            }
        });

        const centers = this.props.centers.list.filter(x => x.isNkrParticipant && x.isDeleted == false);

        const data = this.filteredData();

        return (
            <>
                <div className='container'>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>TICKET GROUPS</div>
                        <div>
                            <Button bsStyle='link' onClick={this.handleAddGroup}>Add Group</Button>
                        </div>
                    </div>

                    <Well bsSize='sm' style={{ marginBottom: 5 }}>
                        <div style={{ paddingLeft: 0, paddingRight: 0, display: 'flex' }}>
                            <div style={{ flexBasis: '31%', display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Category:</div>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.category}
                                    onChange={this.handleCategoryChange}
                                >
                                    <option value={0}>- ALL CATEGORIES -</option>
                                    {this.props.ticketing.categories.map((category, index) =>
                                        <option value={category.id}>{category.description}</option>
                                    )}
                                </FormControl>
                            </div>

                            <div style={{ flexBasis: '37%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Show:</div>
                                <ToggleButtonGroup type='radio' name='swaps' value={this.state.internalExternal} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                                    <ToggleButton type='radio' value={0} className={this.state.internalExternal == 0 ? 'btn-primary' : ''} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} onClick={() => this.handleInternalExternalChange(0)}>All</ToggleButton>
                                    <ToggleButton type='radio' value={1} className={this.state.internalExternal == 1 ? 'btn-primary' : ''} onClick={() => this.handleInternalExternalChange(1)}>Internal</ToggleButton>
                                    <ToggleButton type='radio' value={2} className={this.state.internalExternal == 2 ? 'btn-primary' : ''} onClick={() => this.handleInternalExternalChange(2)}>Not Internal</ToggleButton>
                                </ToggleButtonGroup>
                            </div>

                            <div style={{ flexBasis: '31%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Search:</div>
                                <FormControl
                                    value={this.state.search}
                                    placeholder='Search by group name...'
                                    onChange={this.handleSearchChange}
                                />
                            </div>
                        </div>
                    </Well>

                    <GridWrapper className='ag-theme-bootstrap'>
                        <AgGridReact
                            defaultColDef={{
                                headerClass: 'center-list-header',
                                cellClass: 'center-list-cell'
                            }}
                            columnDefs={this.state.columns}
                            rowData={data}
                            // rowHeight={30}
                            suppressRowClickSelection={true}
                            suppressCellSelection={true}
                        />
                    </GridWrapper>
                </div>

                <GroupAddEdit
                    show={this.state.addEdit.show}
                    data={this.state.addEdit.data}
                    categories={this.props.ticketing.categories}
                    onSave={this.handleAddEditSave}
                    onCancel={this.handleAddEditCancel}
                />

                <GroupUsers
                    show={this.state.groupUsers.show}
                    group={this.state.groupUsers.group}
                    userList={users}
                    centerList={centers}
                    onSave={this.handleEditGroupUsersSave}
                    onCancel={this.handleEditGroupUsersCancel}
                />

                <GroupDelete
                    show={this.state.groupDelete.show}
                    data={this.state.groupDelete.group}
                    onDelete={this.handleDelete}
                    onCancel={this.handleDeleteCancel}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        ticketing: state.ticketing,
        centers: state.centers
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { return dispatch(AppActionCreators.hideLoading()); },
        getTicketGroups: () => { return dispatch(TicketingActionCreators.getTicketGroups()); },
        saveTicketGroup: (group) => { return dispatch(TicketingActionCreators.saveTicketGroup(group)); },
        deleteTicketGroup: (groupId) => { return dispatch(TicketingActionCreators.deleteTicketGroup(groupId)); },
        saveTicketGroupUsers: (request) => { return dispatch(TicketingActionCreators.saveTicketGroupUsers(request)); },
        getUserList: () => { return dispatch(TicketingActionCreators.getUserList([2, 6, 8])); },
        getCenterList: () => { return dispatch(CenterActionCreators.getCenterList()); },
        getTicketGroupCategoryList: () => { return dispatch(TicketingActionCreators.getTicketGroupCategoryList()); }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(GroupList);